(function () {
  new Vue({
    el: '#registerApplication',
    data: {
      api: {
        tenantVerification: '/exists/tenant',
      },
      register: {
        isSubmitted: false,
        stepOne: {
          passed: false,
          verification: 2,
          verificationError: {},
        },
        stepTwo: {
          passed: false,
          verification: 2,
          verificationError: {},
        },
      },
      error: {},
    },
    methods: {
      registerApplication(e) {
        e.preventDefault();
        const stepOne = this.stepOne();

        if (!stepOne) {
          $('#back-1').trigger('click');
          return;
        }

        if (!$('#content-registerform').is(':visible') && this.stepTwo(false)) {
          this.$set('register.isSubmitted', true);
          $('.loadingBarBG').css({ opacity: 1, zIndex: 999 });
          $('#registerForm').submit();
        }
        return true;
      },
      verify(options) {
        const self = this;
        const errorContainer = options.errorContainer || options.error;
        const count = self.register[options.formStep].verification;
        this.$http.get(options.api, options.params)
          .then(() => {
            self.$set(`error.${options.error}`, '');
            self.register[options.formStep].verificationError[options.error] = null;
            if (count <= 2 && count >= 0) {
              self.register[options.formStep].verification += 1;
            }
          }, (error) => {
            if (count <= 2 && count > 0) {
              self.register[options.formStep].verification -= 1;
            }
            const errorMessage = (error.data[errorContainer] && error.data[errorContainer][0]) || 'Some error occurred';
            self.register[options.formStep].verificationError[options.error] = errorMessage;
            self.$set(`error.${options.error}`, errorMessage);
          });
      },
      verifyTenant(prefix) {
        let subDomain = this.register.stepOne.domain;
        subDomain = prefix ? prefix + subDomain : subDomain;
        this.verify({
          api: this.api.tenantVerification,
          params: { params: { subdomain: subDomain } },
          error: 'domain',
          errorContainer: 'subdomain',
          formStep: 'stepOne',
        });
      },
      verifyEmail() {
        this.verify({
          api: this.api.tenantVerification,
          params: { params: { email: this.register.stepOne.email } },
          error: 'email',
          formStep: 'stepOne',
        });
      },
      stepOne() {
        this.$set('formSubmitted', true);
        this.validation('stepOne', ['email', 'password', 'password_confirmation', 'domain']);
        if (!this.register.stepOne.passed
          || this.register.stepOne.verification < 2) {
          return false;
        }

        if (this.register.stepOne.password !== this.register.stepOne.password_confirmation) {
          this.$set('error.password', 'Password and Confirmation password must be same');
          this.$set('error.password_confirmation', this.error.password);
          return false;
        }

        $('#show-registerform-2').trigger('click');
        return true;
      },
      stepTwo(next) {
        this.validation('stepTwo', ['first_name', 'last_name', 'business_name', 'position_title', 'phone_number']);
        if (!this.register.stepTwo.passed) {
          return false;
        }

        if (next) {
          $('#show-paymentform').trigger('click');
        }
        return true;
      },
      validation(formStep, fields) {
        const stepOne = this.register[formStep];
        const self = this;
        let passed = 0;
        fields.forEach((item) => {
          if (!stepOne[item] || !stepOne[item].trim().length) {
            self.$set(`error.${item}`, `${item.replace('_', ' ')} is not provided`);
            return;
          }

          passed++;
          self.$set(`error.${item}`, false);
        });

        this.register[formStep].passed = (passed === fields.length);
        this.verificationValidation(formStep);
      },
      verificationValidation(formStep) {
        for (const key in this.register[formStep].verificationError) {
          if (!this.register[formStep]) return;
          const errorMsg = this.register[formStep].verificationError[key] || false;
          if (errorMsg) {
            this.register[formStep].passed = false;
            this.$set(`error.${key}`, errorMsg);
          }
        }
      },
    },
  });
  $('#registerApplication form').keyup((event) => {
    const srcElement = event.originalEvent.srcElement;
    const parentElement = $(srcElement).parent();

    if (parentElement.hasClass('error')) {
      parentElement.removeClass('error');
    }
  });

  const getDomainWidth1 = $('#domainName1').outerWidth();
  const getDomainWidth2 = $('#domainName2').outerWidth();
  const domainWidth = getDomainWidth1 + getDomainWidth2 + 22;
  $('.domainInput').css({ maxWidth: `calc(100% - ${domainWidth}px)` });
}());
